import Stack from '@mui/material/Stack'

import { PageProps } from '@/Pages/types'
import { FCWithChildren } from '@/types'

import { neutral } from '@/Theme/colors'

import Header from '@/Components/Layout/Header'
import PageHeader from '@/Components/Layout/PageHeader'
import { PageProviderProps } from '@/Components/Pages/PageProvider'

type LayoutProps = PageProps<
  Omit<PageProviderProps, 'showingPageModal' | 'setShowingPageModal'>
>

const Layout: FCWithChildren<LayoutProps> = ({
  children,
  title,
  action,
  modelName
}) => {
  return (
    <Stack flex={1} pb={10} sx={{ backgroundColor: neutral }}>
      <Header />
      {title && (
        <PageHeader title={title} action={action} modelName={modelName} />
      )}
      <Stack
        component="main"
        sx={{
          flex: 1,
          pt: 4
        }}
      >
        {children}
      </Stack>
    </Stack>
  )
}

export default Layout
